/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_identity_pool_id: "us-east-1:b0234c2f-1b65-45ae-9a84-fb774fd74ae5",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_BP7F0pciF",
  aws_user_pools_web_client_id: "2lu594navfchltkopqlmk8luc7",
  oauth: {
    domain: "auth.awardtool.com",
    scope: ["phone", "email", "openid", "profile", "aws.cognito.signin.user.admin"],
    redirectSignIn: "http://localhost:5173/,https://www.awardtool.com/",
    redirectSignOut: "http://localhost:5173/,https://www.awardtool.com/",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};

export default awsmobile